module.exports = __webpack_public_path__ + "img/iphone6.b66b505d.png";